<template>
  <el-dialog v-dialogDrag title="更换主题" :before-close="closeDialog" :visible.sync="isShowDialog" :width="width" center :close-on-click-modal="false">
    <el-card>
      <div style="display: flex">
        <el-button style="margin:0 20px 20px 0; background-color: #008df7; border: none" type="primary" @click="handleChangeTheme('0')">默认主题</el-button>
        <el-button style="margin:0 20px 20px 0; background-color: #264170; border: none" type="primary" @click="handleChangeTheme('theme1')">主题一</el-button>
        <el-button style="margin:0 20px 20px 0; background-color: #f38240; border: none" type="primary" @click="handleChangeTheme('theme2')">主题二</el-button>
        <el-button style="margin:0 20px 20px 0; background-color: #91b198; border: none" type="primary" @click="handleChangeTheme('theme3')">主题三</el-button>
        <el-button style="margin:0 20px 20px 0; background-color: #ff7f9d; border: none" type="primary" @click="handleChangeTheme('theme4')">主题四</el-button>
        <el-button style="margin:0 20px 20px 0; background-color: #c65278; border: none" type="primary" @click="handleChangeTheme('theme5')">主题五</el-button>
      </div>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveTheme">保存</el-button>
      <el-button @click="cancleDialog">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {mapGetters} from 'vuex'
  import LoginApi from "@/api/LoginApi";
  export default {
    name: "change-theme",
    props:{
      width:{
        type:String,
        default:'60vw'
      },
    },
    computed: {
      ...mapGetters(["userInfo",])
    },
    data(){
      return{
        isShowDialog:true,
        theme:'',
      }
    },
    methods:{
      closeDialog(){
        this.$emit('close')
      },
      //选择主题
      handleChangeTheme(val){
        this.theme = val
        val = val == '0' ? '' : val
        window.document.documentElement.setAttribute('data-theme', val)
      },
      //保存
      saveTheme(){
        const loading = this.$loading({
          lock: true,
          text: '请耐心等待.....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let http = new LoginApi()
        let data = {
          accountId:this.userInfo.accountId,
          peName:this.userInfo.name,
          peCo:this.theme,
        }
        http.savePeopleColor(data).then(res => {
          if(res.code == 1){
            loading.close()
            this.$message.success('设置主题成功！')
            this.closeDialog()
          }
        }).catch(e => {
          loading.close()
        })
      },
      //取消
      cancleDialog(){
        const loading = this.$loading({
          lock: true,
          text: '正在重置上次主题，请耐心等待.....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let http = new LoginApi()
        http.getColor({accountId: this.userInfo.accountId}).then(res => {
          let setData = res.data == '0' ? '' : res.data
          window.document.documentElement.setAttribute('data-theme', setData)
          this.closeDialog()
          loading.close()
        }).catch(e => {
          loading.close()
        })
      },
    },
  }
</script>

<style scoped>

</style>
